import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/USOBConfig";

import {
  USOBSegmentsLoading,
  submitUSOBSegmentsActionDispatcher,
  submitUSOBSegmentsErrorDispatcher,
  SUBMIT_USOB_SEGMENTS_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postUSOBSegmentAPI = async () => {
  const result = await AXIOS_INSTANCE.get("/segment")
    // console.log("result: ", result);
  return result ;
};

function* submitUSOBSegmentSaga({ postData }) {
  try {
    yield put(USOBSegmentsLoading(true));
    const data = yield call(postUSOBSegmentAPI, postData);
    yield put(submitUSOBSegmentsActionDispatcher(data));
    yield put(submitUSOBSegmentsErrorDispatcher({}));
    yield put(USOBSegmentsLoading(false));
  } catch (e) {
    yield put(submitUSOBSegmentsActionDispatcher({}));
    yield put(
      submitUSOBSegmentsErrorDispatcher(
        e.response.data,
        console.log(e.response)
      )
    );
    yield put(USOBSegmentsLoading(false));
  }
}

function* submitUSOBSegmentWatcher() {
  yield takeEvery(SUBMIT_USOB_SEGMENTS_ACTION_REQUESTED, submitUSOBSegmentSaga);
}
export default submitUSOBSegmentWatcher;
